/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _) {
    'use strict';

    tabs.$inject = ["mstarDimensions", "mstarState", "mstarTooltip", "$timeout", "$document"];
    angular.module('ecTabs', ['mstarCore']).directive('ecTabs', tabs).directive('ecTab', tab).directive('ecTabLazy', tabLazy).directive('ecTabAction', tabAction);

    function tabs(mstarDimensions, mstarState, mstarTooltip, $timeout, $document) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            transclude: true,
            template: __webpack_require__(4),
            link: linkFn,
            controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
                $scope.tabs = [];

                this.getTabs = function () {
                    return $scope.tabs;
                };
                this.addTab = function (tab, onSelectCallback) {
                    $scope.tabs.push(tab);
                };
                this.getOpenTabSpecs = function () {
                    return $scope.openTabSpecs;
                };
            }]
        };

        function linkFn(scope, elem, attr, mstarComponent, transcludeFn) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            //mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and one-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope);
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            scope.$evalAsync(function () {
                scope.tabType = scope.tabType || 'tabs';
                // todo(slind): remove this, if we want url binding we'll use regular parameter bindings
                scope.state = mstarState.bind({
                    key: scope.queryKey,
                    query: !!scope.queryKey,
                    defaults: {
                        tab: scope.instance.getParameter('selectedTabIndex')
                    }
                });
            });

            scope.showTabPanel = scope.settings.get('showTabPanel');

            var body = $document.find('body');
            body.on('click', function (e) {
                scope.closeDropdown();
            });

            scope.$watch('state.tab', function (newValue) {
                if (!angular.isNumber(newValue)) {
                    return;
                }
                setActiveTabIndex(newValue);
            });

            scope.$watchCollection('tabs', function (newValue) {
                if (newValue.length > 0) {
                    setActiveTabIndex(scope.instance.getParameter('selectedTabIndex'));
                }
            });

            var setActiveTabIndex = function setActiveTabIndex(index) {
                if (index >= scope.tabs.length || index < 0) {
                    return;
                }
                if (!scope.tabs[index].active) {
                    scope.setActiveTab(scope.tabs[index]);
                }
            };

            scope.tabKeyPress = function (tab, event) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                    scope.setActiveTab(tab);
                }
            };

            scope.setActiveTab = function (tab) {
                !tab.active && scope.instance.trigger('ecTabsSelected', [tab.name]);
                _.each(scope.tabs, function (e, i) {
                    var wasActive = e.active;
                    e.active = e === tab;

                    if (e.active === true && morningstar.asterix.util.isFunction(e.onActive)) {
                        e.onActive({ index: i, tab: e });
                    }

                    if (scope.tabs[i].clickCount === undefined) {
                        scope.tabs[i].clickCount = 0;
                    }

                    if (e.active) {
                        scope.tabs[i].clickCount += 1;
                        if (!morningstar.asterix.util.isUndefined(scope.state)) {
                            scope.state.tab = i;
                        }
                        elem.find('.' + scope.namespaceClass('__tab-content')).attr('aria-labelledby', scope.namespaceId('-tab') + i); //.focus();
                        if (scope.settings.get('tooltip').trigger === 'click' && e.tooltipInstance == null) {
                            var tabLink = elem.find('#' + scope.namespaceId('-tab') + i);
                            if (tabLink.length > 0) {
                                e.tooltipInstance = mstarTooltip(scope.$new(), tabLink, { zIndex: 900 });
                                if (e.tooltip && e.tooltip.length > 0) {
                                    e.tooltipInstance.setContent(e.tooltip);
                                    e.tooltipInstance.updatePosition();
                                }
                                //When the tabs is initialized and default active tab is set then there's possibility
                                //that the tooltip was not setup because the anchor tag was not attached to DOM yet
                                //Now that the active tab is clicked again, tooltip should be setup and shown as well
                                if (wasActive) {
                                    e.tooltipInstance.show();
                                }
                            }
                        }
                    } else {
                        if (e.tooltipInstance && scope.settings.get('tooltip').trigger === 'click') {
                            e.tooltipInstance.destroy();
                            e.tooltipInstance = null;
                        }
                    }
                });
                scope.open = false;
            };

            mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:resetTabStatus', function (resetTabStatus) {
                if (resetTabStatus) {
                    _.each(scope.tabs, function (tab) {
                        if (tab.active) {
                            tab.active = false;
                        }
                    });
                    scope.instance.setParameter('resetTabStatus', false);
                }
            }));

            mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:selectedTabIndex', function (selectedTabIndex) {
                setActiveTabIndex(selectedTabIndex);
            }));

            var getActiveTab = function getActiveTab() {
                return _.find(scope.tabs, function (tab) {
                    return tab.active === true;
                });
            };

            scope.getTitle = function () {
                return scope.title ? scope.title : getActiveTab().name;
            };

            scope.closeDropdown = function () {
                $timeout(function () {
                    scope.open = false;
                }, 100);
            };
        }
    }

    function tab() {
        return {
            restrict: 'E',
            require: '^ecTabs',
            template: '<div data-ng-transclude data-ng-show="active"></div>',
            transclude: true,
            replace: true,
            scope: {
                name: '@',
                tooltip: '@',
                ariaLabel: '@'
            },
            link: function link(scope, element, attrs, ecTabs) {
                ecTabs.addTab(scope);
            }
        };
    }

    function tabLazy() {
        return {
            restrict: 'E',
            require: '^ecTabs',
            template: '<div></div>',
            transclude: true,
            replace: true,
            scope: {
                name: '@',
                tooltip: '@',
                ariaLabel: '@'
            },
            link: function link(scope, element, attrs, ecTabs, transcludeFn) {
                ecTabs.addTab(scope);

                var cloneScope = null;

                scope.$watch('active', function (newValue) {
                    if (newValue === true) {
                        cloneScope = scope.$parent.$new();
                        transcludeFn(cloneScope, function (clone) {
                            element.append(clone);
                        });
                    } else if (cloneScope) {
                        cloneScope.$destroy();
                        cloneScope = null;
                        element.empty();
                    }
                });
            }
        };
    }

    function tabAction() {
        return {
            restrict: 'E',
            require: '^ecTabs',
            scope: {
                name: '@',
                onActive: '&',
                ariaLabel: '@'
            },
            link: function link(scope, element, attrs, ecTabs) {
                ecTabs.addTab(scope);
            }
        };
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = {
	"ecTabs": {
		"labels": {},
		"settings": {
			"_parameters": {
				"resetTabStatus": {},
				"selectedTabIndex": {}
			},
			"_templates": {
				"dropdown": "<div class=\"{{::namespaceClass('__dropdown')}}\" data-ng-class=\"open ? namespaceClass('__dropdown--open') : ''\">\r\n    <button class=\"{{::namespaceClass('__btn') + ' ' + namespaceClass('__dropdown-toggle')}}\"\r\n            id=\"{{::namespaceId('-dropdown-btn')}}\"\r\n            data-ng-click=\"open = !open; $event.stopPropagation();\"\r\n            type=\"button\"\r\n            aria-haspopup=\"true\"\r\n            aria-expanded=\"{{open}}\">\r\n        {{ getTitle() }}\r\n        <span class=\"ec-caret\" data-ng-if=\"::settings.get('dropdownCaret') === true\"></span>\r\n    </button>\r\n    <ul class=\"{{::namespaceClass('__dropdown-menu')}}\"\r\n        data-ng-class=\"open ? namespaceClass('__dropdown-menu--open') : ''\"\r\n        role=\"menu\"\r\n        aria-labelledby=\"{{::namespaceId('-dropdown-btn')}}\">\r\n        <li role=\"presentation\" class=\"{{::namespaceClass('__dropdown-item')}}\" data-ng-class=\"[ tab.active ? namespaceClass('__tab--active') : '', tab.header ? namespaceClass('__tab--header') : '', tab.separator ? namespaceClass('__tab--separator') : '']\" data-ng-repeat=\"tab in tabs\">\r\n            <a href=\"javascript:;\"\r\n                class=\"{{::namespaceClass('__dropdown-link')}}\"\r\n                role=\"menuitem\"\r\n                id=\"{{::namespaceId('-tab') + $index}}\"\r\n                data-ng-click=\"setActiveTab(tab)\"\r\n                aria-selected=\"{{tab.active}}\">\r\n                {{ tab.name }}\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n",
				"main": "<div mstar-include=\"templates.tabs\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'tabs'\"></div>\r\n<div mstar-include=\"templates.dropdown\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'dropdown'\"></div>\r\n<div data-ng-show=\"showTabPanel\" data-ng-class=\"{'{{::namespaceClass('__tab-content--standard')}}' : settings.get('tabType') === 'standard'}\" class=\"{{::namespaceClass('__tab-content')}}\" id=\"{{::namespaceId('-tab-content')}}\" role=\"tabpanel\" tabindex=\"-1\" data-ng-transclude></div>\r\n",
				"tabs": "<ul class=\"{{::namespaceClass('__tabs')}}\" role=\"tablist\" data-ng-class=\"settings.get('tabType') === 'standard' ? namespaceClass('__tabs--standard') : ''\">\r\n    <li role=\"presentation\" class=\"{{::namespaceClass('__tab')}}\" data-ng-class=\"tab.active ? namespaceClass('__tab--active') : ''\" data-ng-repeat=\"tab in tabs\">\r\n        <a href=\"javascript:;\"\r\n            class=\"{{::namespaceClass('__link')}}\"\r\n            role=\"tab\"\r\n            id=\"{{namespaceId('-tab') + $index}}\"\r\n            data-ng-click=\"setActiveTab(tab)\"\r\n            data-ng-keypress=\"tabKeyPress(tab, $event)\"\r\n            aria-selected=\"{{tab.active}}\"\r\n            aria-label=\"{{tab.ariaLabel ? tab.ariaLabel : tab.name}}\"\r\n            mstar-tooltip mstar-tooltip-content=\"{{settings.get('tooltip').trigger == 'hover' ? tab.tooltip : ''}}\">{{ tab.name }}</a>\r\n    </li>\r\n</ul>\r\n"
			},
			"controlType": "tabs",
			"dropdownCaret": true,
			"namespaceClass": "ec-tabs",
			"resetTabStatus": false,
			"selectedTabIndex": 0,
			"showTabPanel": true,
			"tabType": "tabs"
		},
		"type": "ecTabs"
	}
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecTabs', __webpack_require__(1).ecTabs);
    morningstar.asterix.meta.register('ecTabs', 'skipInFullIdentifier', true);
    morningstar.asterix.meta.register('ecTabs', 'allowedEvents', ['ecTabsSelected']);

    __webpack_require__(0);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "<div mstar-include=\"templates.tabs\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'tabs'\"></div>\r\n<div mstar-include=\"templates.dropdown\" use-parent-scope=\"true\" data-ng-if=\"settings.get('controlType') === 'dropdown'\"></div>\r\n<div data-ng-show=\"showTabPanel\" data-ng-class=\"{'{{::namespaceClass('__tab-content--standard')}}' : settings.get('tabType') === 'standard'}\" class=\"{{::namespaceClass('__tab-content')}}\" id=\"{{::namespaceId('-tab-content')}}\" role=\"tabpanel\" tabindex=\"-1\" data-ng-transclude></div>\r\n";

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-tabs.js.map


// WEBPACK FOOTER //
// ./components/tabs/build/ec-tabs.js